var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-icon close-button-container" },
    [
      _c("BaseIcon", {
        staticClass: "modal-close-button",
        attrs: {
          icon: "close",
          type: "standard",
          isCustom: true,
          ariaLabel: "close modal dialog"
        },
        on: {
          click: function($event) {
            return _vm.closeButton()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-187342d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187342d6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItems/CloseButton.vue
// module id = null
// module chunks = 